import { render, staticRenderFns } from "./NumberValue.vue?vue&type=template&id=28bedc6b&lang=pug&"
import script from "./NumberValue.vue?vue&type=script&lang=ts&"
export * from "./NumberValue.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports